import { z } from "zod";
import apiClient from "../../../shared/api/client";

const desktopUninstallSchema = z.object({
  id: z.string(),
  userId: z.number().nullable(),
  email: z.string().nullable(),
  reason: z.string().nullable(),
  details: z.string().nullable(),
  appVersion: z.string().nullable(),
  platform: z.string().nullable(),
  osVersion: z.string().nullable(),
  arch: z.string().nullable(),
  installedAt: z.string().nullable(),
  installationType: z.string().nullable(),
  createdAt: z.string(),
});

export type DesktopUninstall = z.infer<typeof desktopUninstallSchema>;

// `data` son los `limit` avisos más recientes y no hay paginación: el total
// tiene que venir del backend o la pantalla termina mostrando el tope (200)
// como si fuera la cantidad de desinstalaciones.
const desktopUninstallsResponseSchema = z.object({
  data: z.array(desktopUninstallSchema),
  meta: z.object({
    total: z.number(),
    limit: z.number(),
  }),
});

export type DesktopUninstallsResponse = z.infer<
  typeof desktopUninstallsResponseSchema
>;

export const fetchDesktopUninstalls = async (
  limit = 200,
): Promise<DesktopUninstallsResponse> => {
  const response = await apiClient.get("/admin/desktop-uninstalls", {
    params: { limit },
  });
  return desktopUninstallsResponseSchema.parse(response.data);
};
